<div class="page-container explorer-container container w-100">
  <app-utility-toolbar
    class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
    [current]="'repBehavior'"
    [vertical]="true"
    [links]="dashboardLinks"
    (toggleCollapse)="toggleNavCollapse()"
  />
  <div
    class="explorer-content-container ps-3"
    [ngClass]="{ collapsed: navCollapsed }"
  >
    <app-rb-grid
      #repBehaviorGrid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getRepBehavior"
    >
      <button
        type="button"
        mat-button
        color="primary"
        class="grid-button header-button"
        [disabled]="fileLoading || repBehaviorGrid.disableSearch(true)"
        (click)="dlXlsx()"
      >
        <span class="button-label-with-icon">
          @if (fileLoading) {
            <mat-spinner diameter="20" />
          } @else {
            <mat-icon>cloud_download</mat-icon>
          }
          Download Excel File
        </span>
      </button>
    </app-rb-grid>
  </div>
</div>
